{"browse_shop":"Naršyti parduotuvę","go_to_shop":"Eiti į parduotuvę","no_orders_found":"Užsakymų nerasta","title":"Užsakymai"}